import "./creditOPenList.css";
import CloseSave from "../../../design/close";


function CreditOpenList({creditList, setClose, onDClick}) {
    return (
        <div className={"CreditOpenList"}>
            <div>
                <p>כרטיסי אשראי</p>

                <CloseSave 
                fs="20pt" 
                setClose={setClose}
                bc="rgb(0, 30, 54)" 
                c="wheat"
                hbc="rgba(127, 214, 255)"
                />

                <CloseSave 
                fs="20pt" 
                setClose={setClose}
                bc="rgb(0, 30, 54)" 
                c="wheat"
                hbc="rgba(127, 214, 255)"
                left={false}
                />
            </div>

            <div>
            {
                creditList.length ?

                Object.entries(creditList[0]).map(([key, value]) => (
                    <div onDoubleClick={() => onDClick({
                        number: value['number'], date: value['date'], cvv: value['cvv'], id: value['id']
                    }, key)}>
                        <p> {value['number']} </p>
                        <p> {value['name']} </p>
                        <p> {value['cvv']} </p>
                    </div>
                ))
                :

                <p>אין כרטיסי אשראי</p>
            }
            </div>
        </div>
    );
}

export default CreditOpenList;
